<template>
  <div>
    <div class="content">
      <div v-if="!timeBlockLoaded">
        <loading></loading>
      </div>
      <div v-else
           class="container-fluid container-fixed-lg">
        <div class="row p-3">
          <div class="col-lg-6 m-b-10 d-flex">
            <div class="card no-border card-condensed no-margin widget-loader-circle align-self-stretch d-flex flex-column">
              <div class="card-header card-header-24 confirm p-b-20">
                <div class="text-center">
                  <router-link class="btn btn-link text-white text-small text-bold"
                               :to="{ name: 'calendar' }">{{ $t('schedule_back_to_schedule') }}
                  </router-link>
                </div>
              </div>
              <div class="clearfix">
              </div>
              <div class="auto-overflow p-2">
                <div id="advies-table">
                  <table class="table table-sm cal-24">
                    <thead>
                      <tr>
                        <th class="text-center">
                          <clock-icon class="clock-24 icon-big" />
                        </th>
                        <th>
                          <div class="th-24">
                            <h2 class="text-success">{{ $t('schedule_advice') }}</h2>
                            <h3 class="sectiontitle2 text-muted">
                              <div class="dienst-tijd">
                                {{ getTimeBlock.Title }}
                              </div>
                            </h3>
                          </div>
                        </th>
                      </tr>
                    </thead>

                    <tr v-for="timebox in timeTable"
                        v-if="timebox.show"
                        class="spaceUnder"
                        :class="getShiftClass.tr[timebox.shift]">
                      <td class="text-center"
                          :class="getShiftClass.td[timebox.shift]">
                        <div class="hourmin">
                          <p class="hours">{{ timebox.hour.slice(0,2) }}</p>
                          <p class="minutes">{{ timebox.hour.slice(2) }}</p>
                        </div>
                      </td>
                      <td v-if="timebox.advice_block"
                          rowspan="4">
                        <div class="p-3">
                          <div class="advicebox p-1"
                               :class="getShiftClass.box[timebox.shift]">
                            <advice-block v-on:open-modal="showModal(getTimeBlock.Ranges[timebox.range_idx])"
                                          :advice-text="getTimeBlock.Ranges[timebox.range_idx].Title">
                            </advice-block>
                          </div>
                        </div>
                      </td>
                      <td v-else>
                      </td>
                    </tr>
                  </table>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

      <advice v-on:close-modal="hideModal"></advice>
  </div>

</template>

<script>
  import { mapGetters } from 'vuex'
  import { mapActions } from 'vuex'
  import { mapMutations } from 'vuex'
  import Advice from './Advice';
  import AdviceBlock from './AdviceBlock';
  import ClockIcon from "vue-material-design-icons/Clock.vue"
  import Loading from '../utilities/Loading.vue'

  export default {
    props: ['shift_type'],
    components: {Advice, AdviceBlock, ClockIcon, Loading},
    computed: {
      ...mapGetters([
        'getShiftClass',
        'getTimeBlock',
      ]),
    },
    methods: {
      ...mapActions([
        'loadTimeBlockAdvice',
        'loadAdviceDetails',
      ]),
      ...mapMutations([
        'HIDE_ADVICE_DETAIL','SET_TIMEFRAME'
      ]),
      showModal (range) {
        this.SET_TIMEFRAME(range.WorkScheduleTimeFrameAdviceId)
        console.log(range)
        this.loadAdviceDetails({adviceId: range.AdviceId, timeframeId: range.WorkScheduleTimeFrameAdviceId}).then(response => {
          console.log(response)
          document.body.classList.add('modal-open')
        }, error => {
          console.error(error)
        })
      },
      hideModal () {
        this.HIDE_ADVICE_DETAIL()
        document.body.classList.remove('modal-open')
      },
      initTimeBlock () {
        let time1 = this.getTimeBlock.From
        let time2 = this.getTimeBlock.To
        let origShowFlag = true

        // if time block setup from late to early
        // if (time1 > time2) {
        //   time2 = this.getTimeBlock.From
        //   time1 = this.getTimeBlock.To
        //   origShowFlag = false
        // }

        // set time block start position
        let temptable = []
        let index = this.timeTable.findIndex((obj => +(obj.hour) == time1))

        if (index < 0) {
          index = 0
          console.log('Missing API params (From, To)')
        }

        while (temptable.length < this.timeTable.length) {
          temptable.push(this.timeTable[index])
          index++
          if (index === this.timeTable.length) {
            index = 0
          }
        }
        this.timeTable = temptable

        for (let idx in this.timeTable) {
          this.timeTable[idx].show = true
          // if (this.timeTable[idx].hour >= time1 && this.timeTable[idx].hour <= time2) {
          //   this.timeTable[idx].show = origShowFlag
          // // } else {
          //   this.timeTable[idx].show = !origShowFlag
          // }

          for (let range_idx in this.getTimeBlock.Ranges) {
            if (this.timeTable[idx].hour >= this.getTimeBlock.Ranges[range_idx].Start && this.timeTable[idx].hour < this.getTimeBlock.Ranges[range_idx].End) {
              this.timeTable[idx].shift = this.getTimeBlock.Ranges[range_idx].ShiftTypeId
              this.timeTable[idx].range_idx = range_idx
              if (this.timeTable[idx].hour == this.getTimeBlock.Ranges[range_idx].Start) {
                this.timeTable[idx].advice_block = true
              }
            }
          }
        }
      },
    },
    created () {
      this.HIDE_ADVICE_DETAIL()
      this.loadTimeBlockAdvice(this.shift_type).then(response => {
        console.log(response)
        this.initTimeBlock()
        this.timeBlockLoaded = true
      }, error => {
        console.error(error)
      })
    },
    data() {
      return {
        timeBlockLoaded: false,
        timeTable: [
          { hour: '1100', shift: 0 },
          { hour: '1130', shift: 0 },
          { hour: '1200', shift: 0 },
          { hour: '1230', shift: 0 },
          { hour: '1300', shift: 0 },
          { hour: '1330', shift: 0 },
          { hour: '1400', shift: 0 },
          { hour: '1430', shift: 0 },
          { hour: '1500', shift: 0 },
          { hour: '1530', shift: 0 },
          { hour: '1600', shift: 0 },
          { hour: '1630', shift: 0 },
          { hour: '1700', shift: 0 },
          { hour: '1730', shift: 0 },
          { hour: '1800', shift: 0 },
          { hour: '1830', shift: 0 },
          { hour: '1900', shift: 0 },
          { hour: '1930', shift: 0 },
          { hour: '2000', shift: 0 },
          { hour: '2030', shift: 0 },
          { hour: '2100', shift: 0 },
          { hour: '2130', shift: 0 },
          { hour: '2200', shift: 0 },
          { hour: '2230', shift: 0 },
          { hour: '2300', shift: 0 },
          { hour: '2330', shift: 0 },
          { hour: '0000', shift: 0 },
          { hour: '0030', shift: 0 },
          { hour: '0100', shift: 0 },
          { hour: '0130', shift: 0 },
          { hour: '0200', shift: 0 },
          { hour: '0230', shift: 0 },
          { hour: '0300', shift: 0 },
          { hour: '0330', shift: 0 },
          { hour: '0400', shift: 0 },
          { hour: '0430', shift: 0 },
          { hour: '0500', shift: 0 },
          { hour: '0530', shift: 0 },
          { hour: '0600', shift: 0 },
          { hour: '0630', shift: 0 },
          { hour: '0700', shift: 0 },
          { hour: '0730', shift: 0 },
          { hour: '0800', shift: 0 },
          { hour: '0830', shift: 0 },
          { hour: '0900', shift: 0 },
          { hour: '0930', shift: 0 },
          { hour: '1000', shift: 0 },
          { hour: '1030', shift: 0 },
        ],
      }
    },
  }
</script>

<style>
  .modal-mask {
    position: fixed;
    z-index: 9998;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background-color: rgba(0, 0, 0, .5);
    display: table;
    transition: opacity .5s ease;
  }

  .modal-wrapper {
    display: table-cell;
    vertical-align: middle;
  }

  .modal-container {
    width: 200px;
    height: 100%;
    margin-left: 50%;
    padding: 5px 5px;
    background-color: #fff;
    border-radius: 2px;
    box-shadow: 0 2px 8px r0gba(0, 0, 0, .33);
    transition: all .5s ease;
    font-family: Helvetica, Arial, sans-serif;
  }

  .modal-header h3 {
    margin-top: 0;
    color: #42b983;
  }

  .modal-body {
    margin: 20px 0;
  }

  .modal-default-button {
    float: right;
  }

  .modal-enter {
    opacity: 0;
    -webkit-transform: translate(200px,0px);
    transform: translate(200px,0px);
  }

  .modal-leave-active {
    opacity: 0;
    -webkit-transform: translate(200px,0px);
    transform: translate(200px,0px);
  }

</style>



// WEBPACK FOOTER //
// src/components/myschedule/TimeBlock.vue